module.exports = {
  cnpj_resumido: process.env.REACT_APP_SOTRAN_CNPJ_RESUMIDO,
};
